import { Clinic } from '@models/clinic';
import { User } from '@models/user';
import { eTreatmentFormCategory } from './etreatment-form-category';

export class eTreatmentForm {
  public id: number;
  public name: string;
  public eTreatmentFormCategoryId: number;
  public eTreatmentFormCategory: eTreatmentFormCategory;
  public createdDate: Date;
  public modifiedDate: Date;
  public formDefinition: string;
  public isDeleted: boolean;
  public isSharedForm: boolean;
  public sharedByUserId: string;
  public sharedByUser: User;
  public sharedByClinicId?: number;
  public sharedByClinic: Clinic;
  public sharedFormCreationDate?: Date;
  public createdByUserId: string;
  public createdByUser: User;

  public constructor(init?: Partial<eTreatmentForm>) {
    Object.assign(this, init);
    if (this.createdDate && typeof this.createdDate == 'string') this.createdDate = new Date(this.createdDate);
    if (this.modifiedDate && typeof this.modifiedDate == 'string') this.modifiedDate = new Date(this.modifiedDate);
    if (this.sharedFormCreationDate && typeof this.sharedFormCreationDate == 'string')
      this.sharedFormCreationDate = new Date(this.sharedFormCreationDate);
  }
}
